




































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import EstimateSubHeader from "@/components/EstimateSubHeader.vue";
import Number from "@/shared/filters/Number";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import ReservationDetailState from "@/store/reservation/state";

@Component({
  components: {
    InputNumber,
    EstimateSubHeader
  },
  filters: { Number }
})
export default class EstimatePreview extends Vue {

  $refs!: {
  };

  @Prop() companyInfo: any;
  @Prop() data: any;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  @Getter("freeOfChargeLabelMini", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  public reqService: requestService = new requestService();
  ippanSeibiService: IppanSeibiService = new IppanSeibiService();

  get optionTitle() {
    return this.ippanSeibiService.isIppanSeibi ? this.optionLabel + "①" : this.optionLabel + "③";
  }

  get couponTitle() {
    return this.ippanSeibiService.isIppanSeibi ? this.couponLabel + "②" : this.couponLabel + "④";
  }

  get shopZip() {
    return `〒-${this.companyInfo.zip1}-${this.companyInfo.zip2}`;
  }

  get addr1() {
    return `${this.companyInfo.prefNm} ${this.companyInfo.addr1}`;
  }

  get addr2() {
    return `${this.companyInfo.addr2}`;
  }

  get shatenNm() {
    return `${this.companyInfo.shatenNm}`;
  }

  get kyotenNm() {
    return `${this.companyInfo.kyotenNm}`;
  }

  get tel() {
    return `TEL:${this.companyInfo.tel1}-${this.companyInfo.tel2}-${this.companyInfo.tel3}`;
  }

  get customer() {
    if (this.reservationState) {
      return this.reservationState.customer;
    }
    return {};
  }

  get staffNm1() {
    if (this.customer) {
      return this.customer.staffNm1;
    }
    return "";
  }

  /** 2021-10-07 sh #7438 implements tech-info-amount for Jizen estimate preview. [START] */
  get isUseTechInfoAmount() {
    return this.data.isUseTechInfoAmount == 1;
  }
  /** 2021-10-07 sh #7438 implements tech-info-amount for Jizen estimate preview. [END] */

  /** 2021-10-08 sh #7458 fix layout at preview. [START] */
  get totalShohiyou() {
    let total = 0;
    const data = this.data;
    total = data.zeiJibaisekiZk + data.zeiWeightTax + data.zeiInshidaiZk;
    /** 2023-10-19 invoice [START] */
    if ( this.isExcludingTax ) {
      total += data.optionZn + data.couponZn + data.kensaHiyou;
    } else {
      total += data.optionZk + data.couponZk + data.kensaHiyou;
    }
    /** 2023-10-19 invoice [END] */

    /** 2021-10-25 sh #7493 fix bug. wrong total kingaku. [START] */
    /** 2023-10-19 invoice [START] */
    /** 2024-04-08 invoice [START] */
    // if ( this.isExcludingTax ) {
    //  this.data.shakenHiyouItems.forEach((item: any) => {
    //    total += item.kingakuZn;
    //  });
    // } else {
    //  this.data.shakenHiyouItems.forEach((item: any) => {
    //    total += item.kingakuZk;
    //  });
    // }
    total += data.calcShakenHiyouTotal;
    /** 2024-04-08 invoice [END] */
    /** 2023-10-19 invoice [END] */
    /** 2021-10-25 sh #7493 fix bug. wrong total kingaku. [END] */

    if (data.isUseTechInfoAmount == 1) {
      total += data.zeiTechInfoAmountZk;
    }

    return total;
  }

  get totalSeibi() {
    return this.data.calcTotal - this.totalShohiyou;
  }
  /** 2021-10-08 sh #7458 fix layout at preview. [END] */

  isRecommend(seibi: any) {
    if (seibi.isRecommend == 1) {
      return "";
    }

    return "icon-recommend-notshow";
  }

  iconRecommendLabel(seibi: any) {
    if (seibi.isRecommend == 1) {
      return '※';
    }
    return ' ';
  }
}
